import gql from 'graphql-tag';
import { parseToMutationRequest } from '../../../utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, ['index', 'serviceType', 'status']);
  const createConfigUsageType = `createConfigUsageType(input: ${dataCreate})`;
  return gql`
    mutation {
      ${createConfigUsageType} {
        id
      }
    }
  `;
};
